<template >
  <div>
    <span class="h3" style="margin-bottom: 15px;"><a-icon type="clock-circle-o" /> Тест не пройден {{id}}</span>
    <div
      class="box"
      v-clipboard:copy="urlQuiz"
      v-clipboard:success="onCopy"
    >
      <span class="boxTitle">Скопировать ссылку на тест</span>
      <span class="link">{{urlQuiz}}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BarGraph from '@/components/BarGraph'

export default {
  name: 'ResultNoData',
  props: ['id', 'urlQuiz'],
  components: {
    BarGraph
  },
  methods: {
    onCopy() {
      this.$message.success('Скопировано')
    }
  },
};
</script>

<style scoped lang='scss'>
@import '../../css/var.scss';

$primeColor: #79E3B8;
$linkColor: #00CA79;

.h3 {
  font-size: 18px;
  font-family: $mainFont;
  line-height: 1.3;
  color: rgba(0,0,0,.5);
  display: block;
}
.box {
  display: inline-block;
  border: 2px solid rgba(0,0,0,.1);
  border-radius: 10px;
  padding: 20px 30px;
  cursor: pointer;
  @include transition;

  &:hover {
    border-color: $primeColor;
  }
}

.boxTitle {
  font-size: 18px;
  font-family: $mainFont;
  line-height: 1.3;
  color: black;
  @include transition;

  .box:hover &, &:hover {
    color: $linkColor;
  }
}

.link {
  display: block;
  font-size: 14px;
  color: rgba(0,0,0,.5);
}

</style>
